<!-- =========================================================================================
    File Name: ChatContact.vue
    Description: Chat contact - single component for chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="chat__contact flex items-center  p-1 "
    :title="contact.display_name || contact.fullName"
  >

    <div class="contact__avatar " :class="contact.is_group ? 'pt-3 pb-3 pl-1':' pt-2 pl-1'">
      <div class="mr-5" v-if="contact.profile_image">
        <b-avatar
          class="border-2 "
                 :class="' light-'+color "
          size="38px"
          href="#"
          
          :src="contact.profile_image"
          
        ></b-avatar>
        <div v-if="isOnline !== null"
          class="h-3 w-3 border-white border border-solid rounded-full online-dot float-right"
          :class="{'bg-success': isOnline, 'bg-danger': !isOnline}"
        ></div>
      </div>
      <div class=" mr-5" v-else>
        <b-avatar
          class="border-2 text-light "
          size="38px"
          href="#"
               :class="' light-'+color "
          :text="(contact.display_name || contact.fullName) | avatar"
        ></b-avatar>
        <div v-if="isOnline !== null"
          class="h-3 w-3 border-white border border-solid rounded-full online-dot float-right"
          :class="{'bg-success': isOnline, 'bg-danger': !isOnline}"
        ></div>
      </div>
      <!-- <vs-avatar class="border-2 border-solid border-white" :src="contact.profile_image" size="42px"   :text="avatarText(contact.fullName )" /> -->
    </div>

    <div
      class="contact__container w-full flex   overflow-hidden" :class="contact.is_group ? '':'pb-1 '"
    > 
      <div class="contact__info flex flex-col truncate">
        <span  
          class="text-h6"
          style="font-size: 16px; line-height: 1.3125rem;"        
         >{{ contact.display_name ? (contact.display_name.length > 25 ? contact.display_name.substring(0,26)+".." : contact.display_name ) 
            : (contact.fullName.length > 25 ? contact.fullName.substring(0,26)+".." : contact.fullName) }}</span>
        <template v-if="contact.user_role">
            {{ contact.user_role == 'user' ?  $t('Client') : $t(contact.user_role) }}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import onlineMixin from '@/views/company/chat/online.mixins';

export default {
  mixins: [onlineMixin],
  data () {
    return {
      selectedChats: []
    }
  },
  props: {
    contact: { type: Object, required: true },
    color: { type: String, default: "" },
  },
  computed: {
    isOnline() {
      if(!this.contact || this.contact.is_group == 1) return null;
      if(this.contact.user_role == 'staff')
        return this.onlineStaffIds.includes(this.contact.user_id);
      return this.onlineClientIds.includes(this.contact.user_id);
    }
  },
  methods: {
   
  },
};
</script>